// extracted by mini-css-extract-plugin
module.exports = {"buttonsInRow":"RwoAC9","button":"_3jK1Qx","buttons":"_3mM0o4","footer":"_2vA693","textCancel":"_2sqGsz"};